export default __webpack_public_path__ + "static/media/default_header_bg@2x.2625edba.png";